const xinjiyuanMenuList = ['PLACE_ORDER', 'COUPON', 'ORDER_BOOKING', 'SHIPPING_BILL', 'DECLARE_ORDER', 'ORDER_TRACKING', 'CONTAINER_ORDER', 'DATA_COMPARE'];

const defaultMenuList = ['PLACE_ORDER', 'COUPON', 'ORDER_BOOKING', 'SHIPPING_BILL', 'DECLARE_ORDER', 'ORDER_TRACKING', 'LCL_ORDER', 'CONTAINER_ORDER', 'DATA_COMPARE', 'FEE_CONFIRMATION', 'DAILY_BILL_QUERY', 'ACCOUNT_CHECKING', ];
// const defaultMenuList = ['MAIN_QUERY_CHARGE', 'PLACE_ORDER', 'COUPON', 'ORDER_BOOKING', 'SHIPPING_BILL', 'DECLARE_ORDER', 'ORDER_TRACKING', 'LCL_ORDER', 'CONTAINER_ORDER', 'DATA_COMPARE', 'FEE_CONFIRMATION', 'DAILY_BILL_QUERY', 'ACCOUNT_CHECKING', ];
// const defaultMenuList = ['CROSS-BORDER-LOGISTICS','MAIN_QUERY_CHARGE', 'PLACE_ORDER', 'COUPON', 'ORDER_BOOKING', 'SHIPPING_BILL', 'DECLARE_ORDER', 'ORDER_TRACKING', 'LCL_ORDER', 'CONTAINER_ORDER', 'DATA_COMPARE', 'FEE_CONFIRMATION', 'DAILY_BILL_QUERY', 'ACCOUNT_CHECKING', ];

export {xinjiyuanMenuList, defaultMenuList};



// WEBPACK FOOTER //
// ./src/api/menuList.js